import { Box } from '@mui/material'
import React from 'react'
import CSIntroduction from './CSIntroduction'
import CSConclusion from './CSConclusion'
import CaseStudyDetailBgLandingPage from './CaseStudyDetailBgLandingPage'
import CaseStudySolutionPage from './CaseStudySolutionPage'
import CaseStudyPromistingResult from './CaseStudyPromistingResult'
import CSChallenges from './CSChallenges'
import CaseStudyAboutClient from './CaseStudyAboutClient'
import CaseStudyDetailContent from './CaseStudyDetailContent'

const CaseStudyDetail = () => {
  return (
    <Box sx={{
        backgroundColor:"#ecebeb" 
      }}  >
      <CaseStudyDetailBgLandingPage/>
      <CSIntroduction/>
      <CaseStudyAboutClient/>
      <CSChallenges/>
      <CaseStudySolutionPage/>
      <CaseStudyPromistingResult/>
      <CSConclusion/>
    </Box>
  )
}

export default CaseStudyDetail
